import React from 'react'
import { Link } from 'react-router-dom'

const LinkRenderer = ({ to, className, children }) => (
  <Link to={to} className={className}>
    {children[1] === 'EFO Rd' ? 'EFORd' : children}
  </Link>
)

export default LinkRenderer
